module.exports = __webpack_public_path__ + "d221bd84a9dc2e74da04e3a674c9a386.svg";